module.exports = __webpack_public_path__ + "img/page7.8fd39205.jpeg";